import { differenceInBusinessDays } from 'date-fns';
import AccountStatus from '../../common/constants/accountStatus';

export function canRequestPwGBPlusCard(migrateStatus) {
  return !!(migrateStatus?.can_migrate && !migrateStatus?.has_migrated);
}

export function canCompleteMigrationToPwGBPlus(accountStatus, shipDate) {
  const hasRequestedNewCard = accountStatus === AccountStatus.MigratedUserCardActivation;
  if (!hasRequestedNewCard || !shipDate) {
    return false;
  }

  let readyToCompleteMigration = true;
  const isProduction = process.env.NODE_ENV === 'production';
  if (isProduction) {
    // NOTE: Production users must wait 3 business days after their card is shipped to activate it
    readyToCompleteMigration = differenceInBusinessDays(new Date(), new Date(shipDate)) > 3;
  }
  return hasRequestedNewCard && readyToCompleteMigration;
}
